<div class="portfolio-box">
  <ng-container *ngIf="!isTopicsLoading; else loadingTopics">
    <ng-container *ngIf="handPrintTopics?.length > 0 || footPrintTopics?.length > 0 || otherTopics?.length > 0; else noTopics">
      <h2 class="ui-headline">{{ 'new_strategy.portfolio_screen.topics_box.title_stocks' | translate }}</h2>

      <ng-container *ngIf="handPrintTopics?.length > 0">
        <h4 class="ui-headline">{{ 'new_strategy.portfolio_screen.topics_box.handprint' | translate }}</h4>
        <div class="topic-grid">
          <div
            *ngFor="let handPrintTopic of handPrintTopics"
            class="topic-item"
            appPopper
            [target]="tooltip"
            arrowClass="topic-tooltip-arrow"
          >
            <img [src]="handPrintTopic.icon" alt="handPrintTopic icon" width="32px" height="32px" />
            <div class="topic-detail">
              <p>{{ handPrintTopic.name }}</p>
            </div>
            <div class="topic-tooltip-content" #tooltip>
              <span class="topic-tooltip-arrow"></span>
              <p>
                <strong>{{ handPrintTopic.name }}</strong>
              </p>
              <p>
                {{ handPrintTopic.desc }}
              </p>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="footPrintTopics?.length > 0">
        <h4 class="ui-headline">{{ 'new_strategy.portfolio_screen.topics_box.footprint' | translate }}</h4>
        <div class="topic-grid">
          <div
            *ngFor="let footPrinttopic of footPrintTopics"
            class="topic-item"
            appPopper
            [target]="tooltip"
            arrowClass="topic-tooltip-arrow"
          >
            <img [src]="footPrinttopic.icon" alt="topic icon" width="32px" height="32px" />
            <div class="topic-detail">
              <p>{{ footPrinttopic.name }}</p>
            </div>
            <div class="topic-tooltip-content" #tooltip>
              <span class="topic-tooltip-arrow"></span>
              <p>
                <strong>{{ footPrinttopic.name }}</strong>
              </p>
              <p>
                {{ footPrinttopic.desc }}
              </p>
            </div>
          </div>
        </div>
      </ng-container>

      <ng-container *ngIf="otherTopics?.length > 0">
        <h4 class="ui-headline">{{ 'new_strategy.portfolio_screen.topics_box.balance' | translate }}</h4>
        <div class="topic-grid">
          <div *ngFor="let otherTopic of otherTopics" class="topic-item" appPopper [target]="tooltip" arrowClass="topic-tooltip-arrow">
            <img [src]="otherTopic.icon" alt="topic icon" width="32px" height="32px" />
            <div class="topic-detail">
              <p>{{ otherTopic.name }}</p>
            </div>
            <div class="topic-tooltip-content" #tooltip>
              <span class="topic-tooltip-arrow"></span>
              <p>
                <strong>{{ otherTopic.name }}</strong>
              </p>
              <p>
                {{ otherTopic.desc }}
              </p>
            </div>
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-template #noTopics>
      <div class="no-topics">
        <h2 class="ui-headline">{{ 'new_strategy.portfolio_screen.topics_box.title_stocks' | translate }}</h2>
        <p>
          {{
            editMode === true
              ? ('new_strategy.portfolio_screen.topics_box.no_topics.p' | translate)
              : ('new_strategy.portfolio_screen.topics_box.no_topics.pStep5' | translate)
          }}
        </p>
        <button *ngIf="editMode === true" class="ui-button secondary" (click)="openTopics()">
          {{ 'new_strategy.portfolio_screen.topics_box.no_topics.cta' | translate }}
        </button>
      </div>
    </ng-template>
  </ng-container>

  <ng-template #loadingTopics>
    <div *ngFor="let load of [].constructor(4)" class="topics skeleton-wrapper">
      <div class="img skeleton"></div>
      <div class="p skeleton"></div>
    </div>
  </ng-template>

  <ng-container *ngIf="customerCriteria?.length > 0">
    <h4 class="ui-headline">{{ 'new_strategy.portfolio_screen.topics_box.title_criteria' | translate }}</h4>
    <div class="criteria-list">
      <div class="criterium" *ngFor="let criterium of customerCriteria" appPopper [target]="tooltip" arrowClass="topic-tooltip-arrow">
        <img [src]="criterium.img" alt="criterium icon" width="32px" height="32px" />
        <p>{{ criterium.name }}</p>
        <div class="topic-tooltip-content" #tooltip>
          <span class="topic-tooltip-arrow"></span>
          <p>
            <strong>{{ criterium.name }}</strong>
          </p>
          <p>
            {{ criterium.desc }}
          </p>
        </div>
      </div>
    </div>
  </ng-container>
</div>
